import { useApiClient } from '../composables/useApiClient.ts';

export default {
    getConfiguration() {
        return useApiClient().get('bookkeepings/ksef-configuration');
    },
    saveConfiguration(data: object) {
        return useApiClient().post('bookkeepings/ksef-configuration', data);
    },
    testConnection(data: { token: string; nip: string }) {
        return useApiClient().post('bookkeepings/ksef-configuration/test-connection', data);
    },
    getAuditLog(query = '') {
        return useApiClient().get(`bookkeepings/ksef-configuration/audit-log${query}`);
    },
};
